import React from 'react';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import { useAppSelector } from 'src/services/redux/app/store';
import { checkIsActive, KTSVG } from '../../../helpers';
import { useLayout } from '../../core';

type Props = {
  to: string;
  title: string;
  icon?: string;
  fontIcon?: string;
  hasBullet?: boolean;
  newFeature?: boolean;
};

const AsideMenuItem: React.FC<Props> = ({ children, to, title, icon, fontIcon, hasBullet = false, newFeature = false }) => {
  const { pathname } = useLocation();
  const isActive = checkIsActive(pathname, to);
  const { config } = useLayout();
  const { aside } = config;
  const { user } = useAppSelector((state) => state.auth);

  const isDisabled = user?.company?.id === 15 && user?.id !== 847;

  return (
    <div className="menu-item">
      <Link
        className={clsx('menu-link without-sub', {
          active: isActive,
          'disabled opacity-50 pe-none': isDisabled,
        })}
        to={isDisabled ? '#' : to}
        title={isDisabled ? 'Erişiminiz yoktur' : ''}
      >
        {hasBullet && (
          <span className="menu-bullet">
            <span className="bullet bullet-dot"></span>
          </span>
        )}
        {icon && aside.menuIcon === 'svg' && (
          <span className="menu-icon">
            <KTSVG path={icon} className="svg-icon-2" />
          </span>
        )}
        {fontIcon && aside.menuIcon === 'font' && <i className={clsx('bi fs-3', fontIcon)}></i>}
        <span className="menu-title">{title}</span>
        {newFeature && <span className="badge badge-primary badge-sm">Yeni</span>}
      </Link>
      {children}
    </div>
  );
};

export { AsideMenuItem };
